export default "__VITE_ASSET__BLXSXwSG__"